import templateUrl from './publishingAtAGlancePreferences.html';
import './publishingAtAGlancePreferences.scss';

import {createLogger} from '../../../common/logging.config';
const logger = createLogger('publishing-at-a-glance-preferences');

class PublishingAtAGlancePreferencesController {
	constructor ($rootScope, $timeout, homepageUtil) {
		this.$rootScope = $rootScope;
		this.$timeout = $timeout;
		this.homepageUtil = homepageUtil;
		
		this.loading = true;
		
		// max allowed values
		this.maxDays = 30;
		this.maxEvents = 50;
		
		// initial settings
		this.toggleValue = true;
		this.maxDaysToShow = 5;
		this.maxEventsToShow = 8;
		this.homepageUtil.getPublishingAtAGlancePreferences().then(rv => {
			// make sure we read something from storage
			if (Object.keys(rv).length > 0) {
				this.toggleValue = rv.onlyMyEvents;
				this.maxDaysToShow = rv.maxDaysToShow;
				this.maxEventsToShow = rv.maxEventsToShow;
			}
			this.loading = false;

			// set initial focus on toggle rather than on title close button
			this.$timeout(() => {
				this.setFocusOnToggle();
				// signal that preferences should be open (done here since x1-popover does not seem to provide)
				this.$rootScope.$emit('preferences-open');
			}, 200);
		});
	}
	
	cancelPreferences() {
		const close = document.querySelector(".x1-ui-popover .close");
		if (close) {
			this.$timeout(() => { close.click();}, 100);
		}
	}
	
	applyPreferences() {
		const userPreferences = {onlyMyEvents: this.toggleValue, maxDaysToShow: this.maxDaysToShow, maxEventsToShow: this.maxEventsToShow};
		this.homepageUtil.setPublishingAtAGlancePreferences(userPreferences).then(rv => {
			// signal to apply the new preferences to pending and published
			this.$rootScope.$emit('apply-preferences', userPreferences);
		});
		this.cancelPreferences();
	}

	// keep the tab focus within our panel
	keyTabFocus(event) {
		if (event.shiftKey === false && event.keyCode === 9 && event.target.id === 'cancelBtn') {
			event.preventDefault();
			this.setFocusOnToggle();
		}
		else if (event.shiftKey === true && event.keyCode === 9 && event.target.id === 'myPublishEventsToggleCheckBox') {
			event.preventDefault();
			const btn = document.querySelector('#cancelBtn');
			btn.focus();
		}
	}
	
	setFocusOnToggle(event) {
		const toggle = document.querySelector('#myPublishEventsToggleCheckBox');
		toggle.focus();
	}
}

export default {
	controller: [ '$rootScope', '$timeout', 'homepageUtil', PublishingAtAGlancePreferencesController ],
	templateUrl
};



// WEBPACK FOOTER //
// ./app/components/publishingAtAGlance/publishingAtAGlancePreferences/publishingAtAGlancePreferences.component.js